import {
  ListAgencyLoggedUser,
  ListUsersLoggedUser,
  LogedUser,
  SecurityLoggedUser,
} from '../../models/logged-user.model';

export type GestionLoginContext = {
  agencyId: number;
  office: string;
  user: string;
  agencyName: string;
  agencyRegion: number | null;
  userFullName: string;
  email: string | null;
  rol: number;
  rolName: string;
  security: SecurityLoggedUser | null;
  currency: string;
  currencyLabel: string;
  showInCurrency: string;
  jupiter: boolean;
  pro: boolean;
  lite: boolean;
  reset: number;
  iListAgency: ListAgencyLoggedUser[];
  listUsers: GestionLoginContext[] | null;
};

export type GestionLoginApiResponse = {
  idToken: string;
  context: GestionLoginContext;
};

export function mapGestionContextToLoggedUser(
  context: GestionLoginContext,
  idToken: string,
  agencyModules: string[] = [],
): LogedUser {
  return {
    id: context.user,
    username: context.user,
    agency_id: context.agencyId,
    agency_name: context.agencyName,
    agency_region: context.agencyRegion ?? 0,
    office: context.office,
    name: context.userFullName,
    email: context.email ?? '',
    role: context.rol,
    rolName: context.rolName,
    security: (context.security ?? {}) as SecurityLoggedUser,
    iListAgency: context.iListAgency ?? [],
    listUsers: (context.listUsers ?? []).map(mapGestionContextToListUser),
    jupiter: context.jupiter,
    pro: context.pro,
    lite: context.lite,
    currency: context.currency,
    currencyLabel: context.currencyLabel,
    showInCurrency: context.showInCurrency,
    reset: context.reset,
    secret: idToken,
    agency_modules: agencyModules,
    haveMessage: false,
    title: '',
    message: '',
    closable: false,
    token: '',
  };
}

export function mapListUserToLoggedUser(
  user: ListUsersLoggedUser,
  idToken: string,
  agencyModules: string[],
): LogedUser {
  return {
    id: user.user,
    username: user.user,
    agency_id: user.agencyId,
    agency_name: user.agencyName,
    agency_region: user.agencyRegion,
    office: user.office,
    name: user.userFullName,
    email: user.email,
    role: user.rol,
    rolName: user.rolName,
    security: user.security,
    iListAgency: user.iListAgency ?? [],
    listUsers: [],
    jupiter: user.jupiter,
    pro: user.pro,
    lite: user.lite,
    currency: user.currency,
    currencyLabel: user.currencyLabel,
    showInCurrency: user.showInCurrency,
    reset: user.reset,
    secret: idToken,
    agency_modules: agencyModules,
    haveMessage: false,
    title: '',
    message: '',
    closable: false,
    token: '',
  };
}

function mapGestionContextToListUser(
  context: GestionLoginContext,
): ListUsersLoggedUser {
  return {
    agencyId: context.agencyId,
    agencyName: context.agencyName,
    agencyRegion: context.agencyRegion ?? 0,
    closable: false,
    currency: context.currency,
    currencyLabel: context.currencyLabel,
    email: context.email ?? '',
    haveMessage: false,
    iListAgency: context.iListAgency ?? [],
    jupiter: context.jupiter,
    listUsers: [],
    message: '',
    password: '',
    reset: context.reset,
    rol: context.rol,
    rolName: context.rolName,
    security: (context.security ?? {}) as SecurityLoggedUser,
    showInCurrency: context.showInCurrency,
    title: '',
    token: '',
    user: context.user,
    userFullName: context.userFullName,
    pro: context.pro,
    lite: context.lite,
    office: context.office,
  };
}
